import { ProcessingOverlay } from '@components'

import { Color, FormItemsGroup } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { AccountSelectWithCreate } from '@features/chartOfAccounts/elements/AccountSelectWithCreate'

import { useFormContext } from '../../../../../../hooks'
import { useOrganizationAccountingSettings } from '../../contexts/organizationAccountingSettingsContext'
import { OrganizationAccountingFormSchema } from '../../utils/organizationAccountingSettingsFormData'
import { ReconciliationViewFormItem } from './elements/ReconciliationViewFormItem/ReconciliationViewFormItem'
import * as Styled from './styles'

export const BankSyncSettings = (): ReactElement => {
  const { t } = useTranslation()
  const { FormItem } = useFormContext<OrganizationAccountingFormSchema>()
  const { isProcessing, isLoading } = useOrganizationAccountingSettings()

  return (
    <Styled.FormFieldsWrapper>
      {(isProcessing || isLoading) && <ProcessingOverlay color={Color.White} />}
      <FormItemsGroup>
        <FormItem
          name="defaultBankFeeAccountId"
          label={t('settings.organization.accounting.bank_fee_account')}
          render={({ field: { onChange, value, ...rest } }) => (
            <AccountSelectWithCreate {...rest} selectedId={value} onSelect={onChange} dropdownSize="fitTrigger" />
          )}
        />
        <ReconciliationViewFormItem />
      </FormItemsGroup>
    </Styled.FormFieldsWrapper>
  )
}
